import { ButtonProps } from '../../atoms/Button';
import { DividerProps } from '../../atoms/Divider';
import { TextProps } from '../../atoms/Text';
import { LabelTextGroupListProps } from '../LabelTextGroupList';


type DetailsBasicInfoSectionInternalProps = {
  text?: TextProps;
  button?: ButtonProps;
  divider?: DividerProps;
  labelTextGroupList?: LabelTextGroupListProps;
};

type DetailsBasicInfoSectionPropsValues = {
  '': DetailsBasicInfoSectionInternalProps;
};

const propValues: DetailsBasicInfoSectionPropsValues = {
  '': {
    text: {
      style: 'Bold',
      align: 'Left',
      colour: 'Default',
      type: 'Heading3',
    },
    button: {
      style: 'Text',
      size: 'Small',
      type: 'TextIcon',
      colour: 'PrimaryAction',
      loading: 'Default',
    },
    divider: {
      type: 'Horizontal',
      style: 'Solid',
      colour: 'BorderBase',
    },
    labelTextGroupList: {
    },
  },
};

const getProps = (type: string): DetailsBasicInfoSectionInternalProps => {
  const values: DetailsBasicInfoSectionInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
